// export const API_BASE = "https://perpx-backend.dev.paraacrypto.com";
// export const API_BASE = "https://backend-v2.api.perpx.ai";
export const API_BASE = "https://backend-dev-api.backend.perpx.ai";
